module.exports = __webpack_public_path__ + "img/841.a2c95315.png";